export var ProfileCompletionStatus = /*#__PURE__*/ function(ProfileCompletionStatus) {
    ProfileCompletionStatus["PartiallyFilled"] = "PartiallyFilled";
    ProfileCompletionStatus["Completed"] = "Completed";
    ProfileCompletionStatus["NotStarted"] = "NotStarted";
    return ProfileCompletionStatus;
}({});
